module.exports = __webpack_public_path__ + "img/quickbi-zizhuqushu.8c5a1f05.svg";